"use client";

import { useState, useRef, useEffect } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import styles from "./ForTutorsMenu.module.css";

export default function ForTutorsMenu() {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const menuRef = useRef(null);
  const pathname = usePathname();

  useEffect(() => {
    const onDown = (e) => {
      if (!menuRef.current || !btnRef.current) return;
      if (!menuRef.current.contains(e.target) && !btnRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const close = () => setOpen(false);
  const isActive = (href) => pathname === href || pathname.startsWith(href);

  return (
    <div className={styles.dropdown}>
      <button
        type="button"
        ref={btnRef}
        className={`${styles.trigger} ${open ? styles.open : ""}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        For Tutors ▾
      </button>

      {open && (
        <div ref={menuRef} role="menu" className={`${styles.menu} ${styles.menuOpen}`}>
          <Link
            href="/create-course"
            className={`${styles.item} ${isActive("/create-course") ? styles.active : ""}`}
            role="menuitem"
            onClick={close}
          >
            Create a Course
          </Link>

          <Link
            href="/tutor/classes"
            className={`${styles.item} ${isActive("/tutor/classes") ? styles.active : ""}`}
            role="menuitem"
            onClick={close}
          >
            Manage My Courses
          </Link>

        </div>
      )}
    </div>
  );
}